export function isXAxisLeftmostDataPoint(
    value: number,
    index: number | undefined
): boolean {
    return index === 0;
}
